import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import classnames from "classnames";

import GlobalMessaging from "features/global_messaging";
import { NOTIFICATION_TYPE } from "apps/notifications_footer/util/constants";

import "./Notification.scss";

const Notification = ({
	type,
	title,
	subtitle,
	redirectPathURL,
	target,
	isViaSpotlight,

	isBoostActivity,
	isHidden,
	hide,
}) => {
	const thumbnail = target.user
		? get(target, "user.primaryImage.square225")
		: get(target, "primaryImageBlurred.square225");
	const onClickClose = (event) => {
		event.preventDefault();
		hide();
	};
	const onClickNotification = (event) => {
		// Messaging events can be handled in global messenger.
		if (type === NOTIFICATION_TYPE.msg_notify) {
			event.preventDefault();
			GlobalMessaging.openConversation(target.user.id);
		}

		// Hide when clicked.
		hide();
	};

	return (
		<a href={redirectPathURL} className="notification-container" onClick={onClickNotification}>
			<div className={classnames("notification", `notification--${type}`, {
				"notification--dispelled": isHidden,
			})}>
				<div className="notification-inner">
					{isViaSpotlight && <span className="notification-indicator" />}

					<img className="notification-img" src={thumbnail} alt="thumbnail" />

					<div className="notification-info">
						<div className="user" dangerouslySetInnerHTML={{ __html: title }} />
						<div className="action">
							{subtitle}
						</div>
					</div>

					{!isBoostActivity && (
						<button
							className="notification-close"
							onClick={onClickClose}
						>
							<span className="icon i-close" />
						</button>
					)}
				</div>
			</div>
		</a>
	);
};

Notification.propTypes = {
	type: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired,
	redirectPathURL: PropTypes.string.isRequired,
	target: PropTypes.oneOfType([
		PropTypes.shape({
			primaryImageBlurred: PropTypes.string.isRequired,
		}),
		PropTypes.shape({
			user: PropTypes.shape({
				id: PropTypes.string.isRequired,
				primaryImage: PropTypes.shape({
					square225: PropTypes.string.isRequired,
				}).isRequired,
			}).isRequired,
		}),
	]).isRequired,

	isBoostActivity: PropTypes.bool.isRequired,
	isViaSpotlight: PropTypes.bool.isRequired,
	isHidden: PropTypes.bool.isRequired,
	hide: PropTypes.func.isRequired,
};

export default Notification;



// WEBPACK FOOTER //
// ./src/apps/notifications_footer/components/Notification.jsx